<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" scrollable max-width="640px">
      <v-card>
        <v-card-title class="headline">
          <h1>Produtos no checkout</h1>
          <v-btn class="close-modal" @click="close()">
            <i class="fal fa-times"></i>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text style="max-height: 60vh">
          <div class="hcp-wrap">
            <p class="hcp-hint">
              Marque quais produtos de doação aparecem no checkout do Hero e use as setas
              <i class="fal fa-arrow-up"></i> <i class="fal fa-arrow-down"></i> para definir a ordem.
            </p>

            <div v-if="loading" class="hcp-msg">Carregando produtos...</div>

            <div v-else-if="!items.length" class="hcp-msg">
              Nenhum produto de doação ativo nesta campanha.
            </div>

            <ul v-else class="hcp-list">
              <li v-for="(item, index) in items" :key="item.id"
                class="hcp-row" :class="{ excluded: !item._selected }">
                <span class="hcp-arrows">
                  <button type="button" class="hcp-arrow" :disabled="index === 0"
                    title="Subir" @click="moveUp(index)">
                    <i class="fal fa-arrow-up"></i>
                  </button>
                  <button type="button" class="hcp-arrow" :disabled="index === items.length - 1"
                    title="Descer" @click="moveDown(index)">
                    <i class="fal fa-arrow-down"></i>
                  </button>
                </span>
                <span class="hcp-pos">{{ index + 1 }}</span>
                <label class="hcp-check">
                  <input type="checkbox" v-model="item._selected" />
                </label>
                <span class="hcp-thumb"
                  :style="item.file && item.file.path ? `background-image: url(${item.file.path})` : ''"></span>
                <span class="hcp-info">
                  <strong>{{ item.name }}</strong>
                  <small>{{ formatValue(item) }}</small>
                </span>
              </li>
            </ul>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="hcp-actions">
          <v-spacer></v-spacer>
          <button class="hcp-btn-cancel" @click="close()">Cancelar</button>
          <button class="hcp-btn-confirm" @click="confirm()">Confirmar</button>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script type="plain/text">
import ProjectService from "@/scripts/services/project.service";

export default {
  props: {
    campaignLandingPageConfig: Object,
  },
  data() {
    return {
      dialog: false,
      loading: false,
      items: [],
      projectService: new ProjectService(),
    };
  },
  methods: {
    open() {
      this.dialog = true;
      this.loading = true;
      this.items = [];
      this.projectService.listAllDonationProductsByCampaignId(
        this.onLoad,
        this.campaignLandingPageConfig.campaignId
      );
    },
    close() {
      this.dialog = false;
      this.$emit("close");
    },
    onLoad(data) {
      const active = (data || []).filter((x) => x.active);
      const savedIds = this.parseSavedOrder();

      if (savedIds.length) {
        const byId = new Map(active.map((p) => [p.id, p]));
        // Produtos salvos que ainda existem, na ordem salva (descarta stale).
        const ordered = savedIds
          .map((id) => byId.get(id))
          .filter(Boolean)
          .map((p) => ({ ...p, _selected: true }));
        // Produtos ativos novos (não estavam na ordem salva) vão ao fim, já marcados.
        const orderedIds = new Set(ordered.map((p) => p.id));
        const appended = active
          .filter((p) => !orderedIds.has(p.id))
          .map((p) => ({ ...p, _selected: true }));
        this.items = ordered.concat(appended);
      } else {
        // Sem configuração: todos ativos, todos marcados.
        this.items = active.map((p) => ({ ...p, _selected: true }));
      }

      this.loading = false;
    },
    parseSavedOrder() {
      try {
        const raw = this.campaignLandingPageConfig.heroCheckoutDonationProductOrder;
        if (!raw) return [];
        const parsed = JSON.parse(raw);
        return Array.isArray(parsed) ? parsed : [];
      } catch (e) {
        return [];
      }
    },
    moveUp(index) {
      if (index <= 0) return;
      const items = this.items.slice();
      const [moved] = items.splice(index, 1);
      items.splice(index - 1, 0, moved);
      this.items = items;
    },
    moveDown(index) {
      if (index >= this.items.length - 1) return;
      const items = this.items.slice();
      const [moved] = items.splice(index, 1);
      items.splice(index + 1, 0, moved);
      this.items = items;
    },
    formatValue(item) {
      if (item.openValue) return "Outros valores";
      const value = item.fixedValue || item.suggestionValue;
      if (!value) return "";
      return "R$ " + Number(value).toLocaleString("pt-BR", { minimumFractionDigits: 2 });
    },
    confirm() {
      const ids = this.items.filter((p) => p._selected).map((p) => p.id);
      this.campaignLandingPageConfig.heroCheckoutDonationProductOrder = JSON.stringify(ids);
      this.$emit("save");
      this.dialog = false;
    },
  },
};
</script>

<style scoped>
.hcp-wrap {
  width: 100%;
  flex: 1 1 100%;
  box-sizing: border-box;
  padding: 20px 24px;
}
.hcp-hint {
  font-size: 13px;
  color: #6b7280;
  margin-bottom: 14px;
}
.hcp-msg {
  padding: 24px 0;
  text-align: center;
  color: #6b7280;
}
.hcp-list {
  list-style: none;
  margin: 0;
  padding: 0;
  width: 100%;
}
.hcp-row {
  display: flex;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
  gap: 12px;
  min-height: 60px;
  padding: 8px 12px;
  margin-bottom: 8px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background: #fff;
  transition: border-color 0.15s, box-shadow 0.15s, opacity 0.15s;
}
.hcp-row:hover {
  border-color: #02acb4;
  box-shadow: 0 1px 6px rgba(2, 172, 180, 0.1);
}
.hcp-row.excluded {
  opacity: 0.45;
}
.hcp-arrows {
  display: flex;
  flex-direction: column;
  flex: 0 0 auto;
  gap: 2px;
}
.hcp-arrow {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 22px;
  border: none;
  border-radius: 4px;
  background: transparent;
  color: #02acb4;
  cursor: pointer;
  line-height: 1;
  padding: 0;
  font-size: 13px;
  transition: background 0.15s;
}
.hcp-arrow:not(:disabled):hover {
  background: rgba(2, 172, 180, 0.1);
}
.hcp-arrow:disabled {
  color: #cbd5e1;
  cursor: default;
}
.hcp-pos {
  flex: 0 0 20px;
  text-align: center;
  font-weight: 700;
  font-size: 13px;
  color: #9ca3af;
}
.hcp-check {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  margin: 0;
}
.hcp-check input {
  width: 18px;
  height: 18px;
  cursor: pointer;
  accent-color: #02acb4;
}
.hcp-thumb {
  flex: 0 0 auto;
  width: 56px;
  height: 44px;
  border: 1px solid #eef0f3;
  border-radius: 6px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  background-color: #fff;
}
.hcp-info {
  display: flex;
  flex-direction: column;
  justify-content: center;
  line-height: 1.3;
  min-width: 0;
  flex: 1 1 auto;
}
.hcp-info strong {
  color: #374151;
  font-size: 14px;
}
.hcp-info small {
  color: #6b7280;
  font-size: 12px;
}
.hcp-actions {
  padding: 12px 24px;
}
.hcp-btn-cancel,
.hcp-btn-confirm {
  border-radius: 6px;
  padding: 8px 18px;
  font-weight: 600;
  cursor: pointer;
  border: none;
}
.hcp-btn-cancel {
  background: transparent;
  color: #6b7280;
}
.hcp-btn-confirm {
  background: #02acb4;
  color: #fff;
  margin-left: 8px;
}
</style>
